module.exports = __webpack_public_path__ + "assets/img/默认产品图.ba4690f0.png";